import PropTypes from 'prop-types';

import {Box, Grid, Paper, Slide} from '@mui/material';

import {AuthLoginForm} from "./AuthLoginForm";
import {OperatorPinInput} from "./OperatorPinInput";
import {useEffect, useRef, useState} from "react";
import {AnimatedBackground} from "./AnimatedBackground";
import {useAuthContext} from "../../auth/useAuthContext";
import {clearSession, getIniLoggedUser} from "../../helper/session";
// ----------------------------------------------------------------------

LoginLayout.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    illustration: PropTypes.string,
};

export default function LoginLayout() {
    const {logout} = useAuthContext();
    const isLogged = getIniLoggedUser();
    const [view, setView] = useState(isLogged ? 'pin' : 'login');
    const containerRef = useRef(null);
    const [isContainerReady, setIsContainerReady] = useState(false);

    useEffect(() => {
        if (containerRef.current) {
            setIsContainerReady(true);
        }
    }, []);

    return (
        <Grid container component="main" sx={{height: '100vh', bgcolor: 'background.default'}}>
            <AnimatedBackground/>
            <Grid
                item xs={12} lg={5} component={Paper} elevation={6} square
                sx={{position: 'relative', overflow: 'hidden'}} ref={containerRef}
            >
                {isContainerReady && (
                    <>
                        <Slide direction="left" in={view === 'login'} container={containerRef.current} mountOnEnter
                               unmountOnExit>
                            <Box sx={{position: 'absolute', width: '100%', height: '100%'}}>
                                <AuthLoginForm onLoginSuccess={() => {
                                    setView('pin')
                                }}/>
                            </Box>
                        </Slide>
                        <Slide direction="left" in={view === 'pin'} container={containerRef.current} mountOnEnter
                               unmountOnExit>
                            <Box sx={{position: 'absolute', width: '100%', height: '100%'}}>
                                <OperatorPinInput onBack={() => {
                                    setView('login')
                                    logout();
                                    clearSession()
                                }}/>
                            </Box>
                        </Slide>
                    </>
                )}
            </Grid>
        </Grid>
    );
}
